export default __webpack_public_path__ + "static/media/edit-icon2.1fcf83e5.svg";